import { regexEmail } from "@api";
import { yupResolver } from "@hookform/resolvers/yup";
import { isValidPhoneNumber } from "@root/utils/phoneLib";
import { type InferType, object, string } from "yup";

export const formContactSchema = object().shape(
  {
    firstName: string(),
    lastName: string(),
    job: string(),
    email: string()
      .matches(regexEmail, {
        message: "Ce champ est mal formaté",
        excludeEmptyString: true,
      })
      .when("phone", {
        is: "",
        then: (schema) => schema.required(),
      }),
    phone: string()
      .test("valid-phone", "Le format du numéro n'est pas valide", (val) => !val || isValidPhoneNumber(val))
      .when("email", {
        is: "",
        then: (schema) => schema.required(),
      }),
  },
  [["email", "phone"]]
);

export const formContactResolver = yupResolver(formContactSchema);
export type TModalFormContactResolver = InferType<typeof formContactSchema>;
